import { Component, Inject } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { SharedModule } from '../../../_shared/shared.module';
import { AbilityService } from '../../../_shared/services/ability.service';
import { SessionService } from '../../../_shared/services/session.service';
import { UtilService } from '../../../_shared/services/util.service';

import { LanguageService } from '../../../languages/shared/language.service';

import { RoomType } from '../../shared/room-type.model';
import { RoomTypeService } from '../../shared/room-type.service';
import { RoomTypeListComponent } from '../../room-type-list/room-type-list.component';
import { RoomTypeDetailComponent } from '../../room-type-detail/room-type-detail.component';

@Component({
  selector: 'app-room-types-modal',
  templateUrl: './room-types-modal.component.html',
  standalone: true,
  imports: [SharedModule, RoomTypeListComponent, RoomTypeDetailComponent],
})
export class RoomTypesModalComponent {
  constructor(
    private roomTypeService: RoomTypeService,
    private languageService: LanguageService,
    private abilityService: AbilityService,
    private sessionService: SessionService,
    private utilService: UtilService,
    private ref: MatDialogRef<RoomTypesModalComponent>,
    @Inject(MAT_DIALOG_DATA) private data
  ) {
    // use it onInit ??
    this.getAdditionalLanguages();
  }

  modalTitle = this.data.title;

  roomTypes: RoomType[];
  meta = [];
  roomType: RoomType;
  mode = '';
  loadingRoomTypes = false;

  listMode = true;
  detailMode = false;

  permissions = {
    canList: this.abilityService.can('index_roomtype_accountadmin'),
    canCreate: this.abilityService.can('create_roomtype_accountadmin'),
  };

  defaultLanguage: any;

  private filterCriteria = this.roomTypeService.getFilterCriteria();
  additionalLanguages = [];

  showRoomTypes() {
    this.modalTitle = this.data.title;

    this.listMode = true;
    this.detailMode = false;

    this.getRoomTypes();
  }

  addRoomType() {
    this.modalTitle = 'ADD_ROOM_TYPE';
    this.listMode = false;
    this.detailMode = true;

    this.roomType = {};
  }

  // Referenced from app-room-type-detail
  onSavedRoomType(roomType) {
    this.roomType = roomType;

    this.listMode = true;
    this.detailMode = false;

    this.getRoomTypes(roomType);
  }

  // Referenced from app-room-type-detail
  onCanceledRoomType() {
    this.showRoomTypes();
  }

  close() {
    this.ref.close(true);
  }

  // Referenced from app-room-type-list
  onSelectedRoomType({ roomType, mode = '' }) {
    this.roomType = roomType;
    this.mode = mode;

    this.modalTitle = 'ROOM_TYPE_DETAILS';
    this.listMode = false;
    this.detailMode = true;
  }

  private getRoomTypes(selectedRoomType = null) {
    this.filterCriteria.lang = this.sessionService.getUserLanguage().code;
    // this.filterCriteria['skip_check_role'] = true;

    this.loadingRoomTypes = true;
    this.roomTypeService.getRoomTypes(this.filterCriteria).subscribe((response) => {
      this.roomTypes = response.data;
      this.meta = response.meta;

      this.loadingRoomTypes = false;

      if (selectedRoomType) {
        this.utilService.changeItemRowStyle(selectedRoomType.id);
      }
    });
  }

  private getAdditionalLanguages() {
    this.languageService.getLanguages({ skip_check_role: true }).subscribe((response) => {
      this.defaultLanguage = response.data.find((language) => language.is_default);
      this.additionalLanguages = response.data.filter((language) => !language.is_default);

      this.getRoomTypes();
    });
  }
}
